import React from "react";
import { LinearProgress } from "@material-ui/core";
import TestAutoReply from "./TestAutoReply";
// import Editor from "./CkEditor";
import TinyEditor from "containers/Tmail/Tmessage/TinyEditor";
const AutoReply = (props) => {
  const {
    saveLoading,
    handleSubmit,
    handleTestSubmit,
    changeFromEmail,
    changeReplyTo,
    changeEmailSubject,
    changeSelectedStatus,
    fromEmail,
    replyTo,
    emailSubject,
    selectedStatus,
    changeReplyMessage,
    replyMessage,
    changeTestEmail,
    testEmail,
    formFilled,
    openAlert,
    handleClickOpen,
    closeAlert,
  } = props;

  return (
    <div style={{ width: "100%", marginLeft: "5px" }} className="row">
      <div className="">
        <form>
          <div className="d-flex">
            <div style={{ width: "485px" }} className="mr-4">
              <label className="mb-2" htmlFor="DomainId">
                From <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                value={fromEmail}
                onChange={(e) => changeFromEmail(e.target.value)}
                placeholder="Enter Response"
              />
            </div>

            <div style={{ width: "485px" }}>
              <label className="mb-2" htmlFor="DomainId">
                Reply to <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                value={replyTo}
                onChange={(e) => changeReplyTo(e.target.value)}
                placeholder="Enter Response"
              />
            </div>
          </div>

          <div className="d-flex mt-3">
            <div style={{ width: "485px" }} className="mr-4">
              <label className="mb-2" htmlFor="DomainId">
                Subject <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                value={emailSubject}
                onChange={(e) => changeEmailSubject(e.target.value)}
                placeholder="Enter Response"
              />
            </div>

            <div style={{ width: "485px" }}>
              <label className="mb-2" htmlFor="DomainId">
                Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                value={selectedStatus}
                onChange={(e) => changeSelectedStatus(e.target.value)}
                placeholder="Enter Response"
              >
                <option>Active</option>
                <option>In Active</option>
              </select>
            </div>
          </div>

          <div className="d-flex mt-3">
            <div className="w-100">
              <label className="mb-2" htmlFor="DomainId">
                Message <span className="text-danger">*</span>
              </label>
              <TinyEditor
                className="form-control"
                value={replyMessage}
                onChange={changeReplyMessage}
                placeholder="Enter Response"
                style={{ height: "221px" }}
              />

              {/* <Editor
                name="description"
                onChange={(data) => {
                  setData(data);
                }}
                editorLoaded={editorLoaded}
              /> */}
            </div>
          </div>

          <div style={{ textAlign: "right", marginTop: "10%" }}>
            <button
              className="btn btn-default mr-2 "
              onClick={handleClickOpen}
              disabled={!formFilled}
              style={
                formFilled
                  ? {
                      color: "#F0B429",
                      background: "#fff",
                      width: "156px",
                      height: "45px",
                      border: "1px solid #F0B429",
                    }
                  : {
                      color: "#B1B1B1",
                      background: "#fff",
                      width: "156px",
                      height: "45px",
                      border: "1px solid #B1B1B1",
                    }
              }
            >
              Test Auto Reply
            </button>

            <button
              className="btn btn-default mr-2 "
              onClick={handleSubmit}
              style={{
                color: "#fff",
                background: "#F7C948",
                width: "156px",
                height: "45px",
              }}
            >
              {formFilled ? "Update" : "Save"}
            </button>

            <div className="mt-2">
              {saveLoading ? (
                <center className="mt-3">
                  <LinearProgress />
                </center>
              ) : null}
            </div>
          </div>
        </form>
        <TestAutoReply
          testEmail={testEmail}
          handleTestSubmit={handleTestSubmit}
          changeTestEmail={changeTestEmail}
          openModal={openAlert}
          handleClose={closeAlert}
        />
      </div>
    </div>
  );
};

export default AutoReply;
